<template>
  <div class="d-flex align-items-center justify-center p-3">
    <div
      id="mapLibre"
      style="width: 100%; height: calc(100vh - 240px);"
    />
  </div>
</template>
<script>
import { isNumber } from 'lodash'
import { GeolocateControl, LngLat, Map, Marker, NavigationControl, Popup } from 'maplibre-gl'

export default {
  name: 'GeoLocationMap',

  props: {
    coords: {
      type: Object,
      default: () => ({
        longitude: '',
        latitude: ''
      })
    },
    enabled: {
      type: Boolean,
      default: true
    }
  },

  emits: [
    'updated:coords'
  ],

  data () {
    return {
      map: null,
      marker: null,
      watcherId: null,
      aljayCoords: {
        longitude: 121.5886181,
        latitude: 16.6965175
      },
      places: {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              properties: {
                description: '<strong>Make it Mount Pleasant</strong><p><a href="http://www.mtpleasantdc.com/makeitmtpleasant" target="_blank" title="Opens in a new window">Make it Mount Pleasant</a> is a handmade and vintage market and afternoon of live entertainment and kids activities. 12:00-6:00 p.m.</p>',
                icon: 'theatre'
              },
              geometry: {
                type: 'Point',
                coordinates: [121.5886181, 16.6965175]
              }
            }
            // {
            //   type: 'Feature',
            //   properties: {
            //     description: '<strong>Mad Men Season Five Finale Watch Party</strong><p>Head to Lounge 201 (201 Massachusetts Avenue NE) Sunday for a <a href="http://madmens5finale.eventbrite.com/" target="_blank" title="Opens in a new window">Mad Men Season Five Finale Watch Party</a>, complete with 60s costume contest, Mad Men trivia, and retro food and drink. 8:00-11:00 p.m. $10 general admission, $20 admission and two hour open bar.</p>',
            //     icon: 'theatre'
            //   },
            //   geometry: {
            //     type: 'Point',
            //     coordinates: [122.003168, 14.894651]
            //   }
            // },
            // {
            //   type: 'Feature',
            //   properties: {
            //     description: '<strong>Big Backyard Beach Bash and Wine Fest</strong><p>EatBar (2761 Washington Boulevard Arlington VA) is throwing a <a href="http://tallulaeatbar.ticketleap.com/2012beachblanket/" target="_blank" title="Opens in a new window">Big Backyard Beach Bash and Wine Fest</a> on Saturday, serving up conch fritters, fish tacos and crab sliders, and Red Apron hot dogs. 12:00-3:00 p.m. $25.grill hot dogs.</p>',
            //     icon: 'bar'
            //   },
            //   geometry: {
            //     type: 'Point',
            //     coordinates: [121.090372, 13.881189]
            //   }
            // },
            // {
            //   type: 'Feature',
            //   properties: {
            //     description: '<strong>Ballston Arts & Crafts Market</strong><p>The <a href="https://ballstonarts-craftsmarket.blogspot.com/" target="_blank" title="Opens in a new window">Ballston Arts & Crafts Market</a> sets up shop next to the Ballston metro this Saturday for the first of five dates this summer. Nearly 35 artists and crafters will be on hand selling their wares. 10:00-4:00 p.m.</p>',
            //     icon: 'art-gallery'
            //   },
            //   geometry: {
            //     type: 'Point',
            //     coordinates: [121.111561, 12.882342]
            //   }
            // },
            // {
            //   type: 'Feature',
            //   properties: {
            //     description: '<strong>Seersucker Bike Ride and Social</strong><p>Feeling dandy? Get fancy, grab your bike, and take part in this year\'s <a href="http://dandiesandquaintrelles.com/2012/04/the-seersucker-social-is-set-for-june-9th-save-the-date-and-start-planning-your-look/" target="_blank" title="Opens in a new window">Seersucker Social</a> bike ride from Dandies and Quaintrelles. After the ride enjoy a lawn party at Hillwood with jazz, cocktails, paper hat-making, and more. 11:00-7:00 p.m.</p>',
            //     icon: 'bicycle'
            //   },
            //   geometry: {
            //     type: 'Point',
            //     coordinates: [121.052477, 10.943951]
            //   }
            // },
            // {
            //   type: 'Feature',
            //   properties: {
            //     description: '<strong>Capital Pride Parade</strong><p>The annual <a href="https://www.capitalpride.org/parade" target="_blank" title="Opens in a new window">Capital Pride Parade</a> makes its way through Dupont this Saturday. 4:30 p.m. Free.</p>',
            //     icon: 'rocket'
            //   },
            //   geometry: {
            //     type: 'Point',
            //     coordinates: [121.043444, 11.909664]
            //   }
            // },
            // {
            //   type: 'Feature',
            //   properties: {
            //     description: '<strong>Muhsinah</strong><p>Jazz-influenced hip hop artist <a href="https://www.muhsinah.com" target="_blank" title="Opens in a new window">Muhsinah</a> plays the <a href="https://www.blackcatdc.com">Black Cat</a> (1811 14th Street NW) tonight with <a href="https://www.exitclov.com" target="_blank" title="Opens in a new window">Exit Clov</a> and <a href="https://godsilla.bandcamp.com" target="_blank" title="Opens in a new window">Gods’illa</a>. 9:00 p.m. $12.</p>',
            //     icon: 'music'
            //   },
            //   geometry: {
            //     type: 'Point',
            //     coordinates: [123.031706, 16.914581]
            //   }
            // },
            // {
            //   type: 'Feature',
            //   properties: {
            //     description: '<strong>A Little Night Music</strong><p>The Arlington Players\' production of Stephen Sondheim\'s  <a href="http://www.thearlingtonplayers.org/drupal-6.20/node/4661/show" target="_blank" title="Opens in a new window"><em>A Little Night Music</em></a> comes to the Kogod Cradle at The Mead Center for American Theater (1101 6th Street SW) this weekend and next. 8:00 p.m.</p>',
            //     icon: 'music'
            //   },
            //   geometry: {
            //     type: 'Point',
            //     coordinates: [120.020945, 16.878241]
            //   }
            // },
            // {
            //   type: 'Feature',
            //   properties: {
            //     description: '<strong>Truckeroo</strong><p><a href="http://www.truckeroodc.com/www/" target="_blank">Truckeroo</a> brings dozens of food trucks, live music, and games to half and M Street SE (across from Navy Yard Metro Station) today from 11:00 a.m. to 11:00 p.m.</p>',
            //     icon: 'music'
            //   },
            //   geometry: {
            //     type: 'Point',
            //     coordinates: [119.007481, 16.876516]
            //   }
            // }
          ]
        }
      },
      proxyCoords: {
        longitude: 0,
        latitude: 0
      }
    }
  },

  watch: {
    proxyCoords: {
      handler (coords) {
        if (this.enabled) {
          this.$emit('updated:coords', {
            longitude: coords?.longitude || 0,
            latitude: coords?.latitude || 0
          })
        }
      },
      deep: true
    }
  },

  beforeDestroy () {
    if (this.watcherId) {
      navigator.geolocation.clearWatch(this.watcherId)
    }

    if (this.map) {
      this.map.remove()
    }
  },

  methods: {

    getReverseGeocoding (latitude, longitude) {
      // const email = process.env.VUE_REVERSE_MAP_EMAIL || ''
      return new Promise((resolve, reject) => {
        const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`

        fetch(url).then(response => response.json()).then(resolve).catch(reject)
      })
    },

    getCurrentPosition () {
      navigator.geolocation.getCurrentPosition(
        ({ coords }) => {
          this.proxyCoords = Object.assign(this.proxyCoords, {
            longitude: coords?.longitude || 0,
            latitude: coords?.latitude || 0
          })
        },
        () => {
          this.proxyCoords = Object.assign(this.proxyCoords, {
            longitude: 0,
            latitude: 0
          })
        },
        {
          enableHighAccuracy: false,
          timeout: 3000,
          maximumAge: 60000
        }
      )
    },

    initLocationWatcher () {
      this.watcherId = navigator.geolocation.watchPosition(
        ({ coords }) => {
          this.proxyCoords = Object.assign(this.proxyCoords, {
            longitude: coords?.longitude || 0,
            latitude: coords?.latitude || 0
          })
        },
        () => {
          this.proxyCoords = Object.assign(this.proxyCoords, {
            longitude: 0,
            latitude: 0
          })
        },
        {
          enableHighAccuracy: false,
          timeout: 3000,
          maximumAge: 60000
        }
      )
    },

    initMap () {
      // if (this.enabled) {
      //   this.getCurrentPosition()
      // }

      this.map = new Map({
        container: 'mapLibre',
        style: {
          version: 8,
          sources: {
            osm: {
              type: 'raster',
              tiles: [
                'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png',
                'https://b.tile.openstreetmap.org/{z}/{x}/{y}.png',
                'https://c.tile.openstreetmap.org/{z}/{x}/{y}.png'
              ],
              tileSize: 256,
              attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>'
            }
          },
          layers: [
            {
              id: 'osm-layer',
              type: 'raster',
              source: 'osm'
            }
          ]
        },
        center: [
          this.coords?.longitude || this.aljayCoords.longitude,
          this.coords?.latitude || this.aljayCoords.latitude
        ],
        zoom: 17,
        maxZoom: 18,
        minZoom: 6,
        interactive: true,
        doubleClickZoom: false,
        maxBounds: [
          [116.5, 4.3], // Southwest coordinates
          [127.0, 21.5] // Northeast coordinates
        ],
        maxBoundsViscosity: 1.0
      })

      const navigation = new NavigationControl()

      const geolocate = new GeolocateControl({
        positionOptions: {
          enableHighAccuracy: false, // disable for long checking of more precise location
          timeout: 3000,
          maximumAge: 60000
        },
        trackUserLocation: true
      })

      geolocate.on('geolocate', currentPosition => {
        const coords = currentPosition?.coords

        this.proxyCoords = Object.assign(this.proxyCoords, {
          longitude: coords?.longitude || 0,
          latitude: coords?.latitude || 0
        })

        geolocate._geolocateButton.setAttribute('disabled', true)
      })

      if (this.enabled) {
        this.map.addControl(geolocate, 'bottom-right')
      }

      this.map.addControl(navigation, 'bottom-right')

      this.map.once('load', () => {
      // // Add a layer showing the places.
      //   this.map.addLayer({
      //     id: 'places',
      //     type: 'symbol',
      //     source: 'places',
      //     layout: {
      //       'icon-image': '{icon}',
      //       'icon-overlap': 'always'
      //     }
      //   })

        if (!this.enabled) {
          const { longitude, latitude } = this.coords

          // Philippine latitudes and longitudes are always positive, Southern and Western Hemisphere is negative
          if ([longitude, latitude].every(number => isNumber(number) && number > 0)) {
            if (!this.marker) {
              const longLat = new LngLat(longitude, latitude)
              const popup = new Popup({
                className: 'min-w-325px'
              })

              this.marker = new Marker()
              this.marker.setLngLat(longLat)
              this.marker.addTo(this.map)

              this.getReverseGeocoding(latitude, longitude).then(
                ({ display_name: address }) => {
                  // let shortAddress = `${address.quarter}, ${address.state}`
                  // if (address?.village) {
                  //   shortAddress = `${address.village}, ${address.state}`
                  // } else if (address?.neighbourhood) {
                  //   shortAddress = `${address.neighbourhood}, ${address.quarter}, ${address.state}`
                  // } else if (address?.town) {
                  //   shortAddress = `${address.quarter}, ${address.town}, ${address.state}`
                  // }
                  // const extendedAddress = address?.postcode ? `${address.region}, ${address.country}, ${address.postcode}` : `${address.region}, ${address.country}`

                  popup.setHTML(
                    `
                      <div class="text-center">
                        <div>${address}</div>
                        <div class="mt-2">Coordinates: </div>
                        <div>Longitude: <b>${longitude}</b></div>
                        <div>Latitude: <b>${latitude}</b></div>
                        <div class="mt-2">
                          <a href="https://www.google.com/maps?q=${latitude},${longitude}" target="_blank">
                            Open in Google Maps
                          </a>
                        </div>
                      </div>
                    `
                  )

                  this.marker.setPopup(popup)
                }
              ).catch(() => {
                popup.setHTML(
                  `
                    <div class="text-center">
                      <div>Address not found</div>
                      <div class="mt-2">Coordinates</div>
                      <div>Longitude: <b>${longitude}</b></div>
                      <div>Latitude: <b>${latitude}</b></div>
                      <div class="mt-2">
                        <a href="https://www.google.com/maps?q=${latitude},${longitude}" target="_blank">
                          Open in Google Maps
                        </a>
                      </div>
                    </div>
                  `
                )
                this.marker.setPopup(popup)
              }).finally(() => {
                this.marker.togglePopup()
              })
            }

            this.map.flyTo({
              duration: 2.25,
              easing: t => t * t * t,
              animate: true,
              essential: true,
              center: [longitude, latitude],
              zoom: 18
            })
          }

          return
        }

        geolocate.trigger()
      })

      this.map.on('dblclick', () => {
        const center = this.enabled ? [
          geolocate._lastKnownPosition.coords.longitude,
          geolocate._lastKnownPosition.coords.latitude
        ] : [
          this.coords?.longitude || this.proxyCoords.longitude,
          this.coords?.latitude || this.proxyCoords.latitude
        ]

        this.map.flyTo({
          duration: 2.25,
          easing: t => t * t * t,
          animate: true,
          essential: true,
          center,
          zoom: 18
        })
      })

      this.map.on('error', () => {
        if (this.enabled) {
          this.initLocationWatcher()
        }
      })

      // // for adding of retails or warehouses locations

      // // When a click event occurs on a feature in the places layer, open a popup at the
      // // location of the feature, with description HTML from its properties.
      // this.map.on('click', 'places', e => {
      //   const coordinates = e.features[0].geometry.coordinates.slice()
      //   const description = e.features[0].properties.description

      //   // Ensure that if the map is zoomed out such that multiple
      //   // copies of the feature are visible, the popup appears
      //   // over the copy being pointed to.
      //   while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
      //     coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360
      //   }

      //   const popup = new Popup()
      //     .setLngLat(coordinates)
      //     .setHTML(description)

      //   popup.addTo(this.map)
      // })

      // // Change the cursor to a pointer when the mouse is over the places layer.
      // this.map.on('mouseenter', 'places', () => {
      //   this.map.getCanvas().style.cursor = 'pointer'
      // })

      // // Change it back to a pointer when it leaves.
      // this.map.on('mouseleave', 'places', () => {
      //   this.map.getCanvas().style.cursor = ''
      // })
    }

  }
}
</script>
